import React from 'react'

const Contact = () => {
  return (
    <main className="content-page">Contact</main>
  )
}

export default Contact